const AppointmentSetterSvg = ({ className }: { className?: string }) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      className={className}
   >
      <g clipPath="url(#clip0_164_1084)">
         <path
            d="M26.057 2.99967H24.7236V1.66634C24.7236 0.930341 24.1276 0.333008 23.3903 0.333008C22.653 0.333008 22.057 0.930341 22.057 1.66634V2.99967H11.3903V1.66634C11.3903 0.930341 10.7943 0.333008 10.057 0.333008C9.31963 0.333008 8.72363 0.930341 8.72363 1.66634V2.99967H7.3903C3.7143 2.99967 0.723633 5.99034 0.723633 9.66634V25.6663C0.723633 29.3423 3.7143 32.333 7.3903 32.333H26.057C29.733 32.333 32.7236 29.3423 32.7236 25.6663V9.66634C32.7236 5.99034 29.733 2.99967 26.057 2.99967ZM7.3903 5.66634H26.057C28.2623 5.66634 30.057 7.46101 30.057 9.66634V10.9997H3.3903V9.66634C3.3903 7.46101 5.18497 5.66634 7.3903 5.66634ZM26.057 29.6663H7.3903C5.18497 29.6663 3.3903 27.8717 3.3903 25.6663V13.6663H30.057V25.6663C30.057 27.8717 28.2623 29.6663 26.057 29.6663ZM24.4996 17.869C25.0116 18.3983 24.9956 19.2437 24.4663 19.7543L18.1463 25.845C17.409 26.5823 16.4036 26.9997 15.3356 26.9997C14.2676 26.9997 13.2623 26.5837 12.5076 25.8277L9.50497 23.0383C8.9663 22.537 8.9343 21.693 9.43563 21.1543C9.93963 20.6143 10.7823 20.585 11.3196 21.085L14.357 23.9077C14.9343 24.481 15.7743 24.4437 16.2756 23.9423L22.6143 17.833C23.145 17.3223 23.9876 17.3383 24.4996 17.8677V17.869Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_164_1084">
            <rect
               width="32"
               height="32"
               fill="white"
               transform="translate(0.723633 0.333008)"
            />
         </clipPath>
      </defs>
   </svg>
)

export default AppointmentSetterSvg
